import * as React from 'react';

import { Filelink } from 'filestack-js';
import Loading from './Loading';
import { AVATAR_TYPES, DEFAULT_AVATAR, FILESTACK_API_KEY } from '../constants';

interface AvatarProps {
  avatarId: string;
  type: keyof typeof AVATAR_TYPES;
}

interface AvatarState {
  image: HTMLImageElement;
  loading: boolean;
}

class Avatar extends React.Component<AvatarProps, AvatarState> {
  constructor(props: AvatarProps) {
    super(props);
    this.state = {
      image: new Image(),
      loading: true,
    };
  }

  public componentDidMount() {
    this.buildImage();
  }

  private buildImage = () => {
    const { image } = this.state;
    const { avatarId, type } = this.props;

    image.onload = () => {
      this.setState({ loading: false });
    };

    image.onerror = () => {
      image.src = DEFAULT_AVATAR;
      image.classList.add('fallback-image');
    };

    const src = new Filelink(avatarId, FILESTACK_API_KEY);
    src.resize({ width: AVATAR_TYPES[type], height: AVATAR_TYPES[type] });
    image.src = src.toString();
  };

  public componentDidUpdate(prevProps: AvatarProps) {
    if (prevProps.avatarId !== this.props.avatarId) this.buildImage();
  }

  public render() {
    const { image, loading } = this.state;
    const { type } = this.props;
    const size = AVATAR_TYPES[type];
    return (
      <div
        style={{
          height: `${size}px`,
          width: `${size}px`,
          margin: 'auto',
        }}
      >
        {loading ? (
          <Loading size="fa-4x" />
        ) : (
          <img
            src={image.src}
            style={{
              maxHeight: `${size}px`,
              maxWidth: `${size}px`,
            }}
            className={`user-avatar ${image.className}`}
          />
        )}
      </div>
    );
  }
}

export default Avatar;
